
export function sweetWarning(title, message) {

    if (typeof window.$swal === 'function') {
        window.$swal({
            title: title,
            html: message,
            icon: 'warning',
        });
    } else {
        console.error('SweetAlert2 is not initialized.');
    }
}

export function sweetError(title, message) {

    if (typeof window.$swal === 'function') {
        window.$swal({
            title: title,
            html: message,
            icon: 'error',
        });
    } else {
        console.error('SweetAlert2 is not initialized.');
    }
}

export function sweetSuccess(title, message) {

    if (typeof window.$swal === 'function') {
        window.$swal({
            title: title,
            html: message,
            icon: 'success',
        });
    } else {
        console.error('SweetAlert2 is not initialized.');
    }
}